import { Action } from '../actions'
import {
  RESOURCE_EMBED_CONFIG_FETCH_REQUESTED,
  RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED,
  RESOURCE_EMBED_CONFIG_FETCH_FAILED,
} from '../actionTypes'

const initialState = {
  embedConfigLoaded: false,
  embedConfig: undefined,
  message: undefined,
}

// Assign the arrow function to a named constant
const activeResourceReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case RESOURCE_EMBED_CONFIG_FETCH_REQUESTED:
      return {
        ...state,
      }
    case RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED:
      const { config } = action.payload
      return {
        ...state,
        embedConfig: config,
        embedConfigLoaded: true,
      }
    case RESOURCE_EMBED_CONFIG_FETCH_FAILED:
      const { embedConfigMessage } = action.payload
      return {
        ...state,
        embedConfig: undefined,
        embedConfigLoaded: false,
        message: embedConfigMessage,
      }
    default:
      return state
  }
}

// Export the named constant as the default export
export default activeResourceReducer
